// extracted by mini-css-extract-plugin
export default {"formSectionWrapper":"FormSection_formSectionWrapper__I0U61","col":"FormSection_col__X3uJp"};